import { render, staticRenderFns } from "./SelectableServiceResource.vue?vue&type=template&id=01e8917d&"
import script from "./SelectableServiceResource.vue?vue&type=script&lang=ts&"
export * from "./SelectableServiceResource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports